/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonStammMasterId } from './personStammMasterId';
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { PersonGbRolleMitRecht } from './personGbRolleMitRecht';
import { PersonGbMasterId } from './personGbMasterId';
import { PersonGbVersionDetailEntryMeta } from './personGbVersionDetailEntryMeta';


export interface PersonGbMasterDetailEntryMeta { 
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    personGbArt?: PersonGbMasterDetailEntryMeta.PersonGbArtEnum;
    mPersonGbArt?: FieldMetaData;
    hasAuskunftssperre?: PersonGbMasterDetailEntryMeta.HasAuskunftssperreEnum;
    mHasAuskunftssperre?: FieldMetaData;
    id?: PersonGbMasterId;
    mId?: FieldMetaData;
    rolleMitRecht?: PersonGbRolleMitRecht;
    mRolleMitRecht?: FieldMetaData;
    egbpid?: string;
    mEgbpid?: FieldMetaData;
    personstammMasterId?: PersonStammMasterId;
    mPersonstammMasterId?: FieldMetaData;
    versions?: Array<PersonGbVersionDetailEntryMeta>;
    mVersions?: FieldMetaData;
    mitglieder?: Array<PersonGbMasterDetailEntryMeta>;
    mMitglieder?: FieldMetaData;
    isAuslaendischeRechtsform?: boolean;
    mIsAuslaendischeRechtsform?: FieldMetaData;
}
export namespace PersonGbMasterDetailEntryMeta {
    export type PersonGbArtEnum = 'ALLE_PERSON' | 'NATUERLICHE_PERSON' | 'JURISTISCHE_PERSON' | 'GEMEINSCHAFT' | 'OEFFENTLICH_RECHTLICHE_PERSON';
    export const PersonGbArtEnum = {
        ALLEPERSON: 'ALLE_PERSON' as PersonGbArtEnum,
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as PersonGbArtEnum,
        JURISTISCHEPERSON: 'JURISTISCHE_PERSON' as PersonGbArtEnum,
        GEMEINSCHAFT: 'GEMEINSCHAFT' as PersonGbArtEnum,
        OEFFENTLICHRECHTLICHEPERSON: 'OEFFENTLICH_RECHTLICHE_PERSON' as PersonGbArtEnum
    };
    export type HasAuskunftssperreEnum = 'AUSKUNFT_SPERRE' | 'ADRESS_SPERRE' | 'KEINE';
    export const HasAuskunftssperreEnum = {
        AUSKUNFTSPERRE: 'AUSKUNFT_SPERRE' as HasAuskunftssperreEnum,
        ADRESSSPERRE: 'ADRESS_SPERRE' as HasAuskunftssperreEnum,
        KEINE: 'KEINE' as HasAuskunftssperreEnum
    };
}


